import React from 'react';
import axios from 'axios';
import {Card, Row, Modal, Col, Typography, Icon, Select as _Select} from 'antd';
import moment from 'moment';
import {connect} from 'react-redux';
import * as etiquetas from '../../ApplicationResources';
import {valueUpperCase} from '../../utils/funciones.js';
import InputText from '../interfaz/InputText';
import Checkbox from '../interfaz/Checkbox';
import Calendario from '../interfaz/Calendario';
import Select from '../interfaz/Select';
import errorImgModal from '../../img/error_icon.svg';

const { Text } = Typography;
const {Option} = _Select;

class DatosPersonales extends React.Component {

    constructor(props) {
        // Calling the constructor of
        // Parent Class React.Component
        super(props);

        // Setting the initial state
        this.state = {
            edad : null,
            modifica: false,
            txtGeneroOtroVisible : true,
            txtTransgeneroOtroDeshabilitado : true,
            msjError : "",
            abrirModalError : false,
            fechaContratacionSE : undefined
        };

        this.handleApellidoPaternoChange =
                                    this.handleApellidoPaternoChange.bind(this);
        this.handleApellidoMaternoChange =
                                    this.handleApellidoMaternoChange.bind(this);
        this.handleCorreoBlur = this.handleCorreoBlur.bind(this);
    }

    componentDidMount() {
        if(this.props.modifica === true){  // si es modifica entonces desaparece el  guia de estatus
            const usuarioInterno = (this.props.datosUsuario && this.props.datosUsuario.tipoUsuario === 'I'?true:false);
            const modifica = !usuarioInterno && this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['correoElectronico'].value
                         && this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['confirmaCorreoElectronico'].value !== null ? true : false;
            this.setState({ modifica : modifica
            });

            this.handleSexoChange(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['sexo'].value);
            this.handleTransgeneroOtroChange(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['transgenero'].value);
        } else{
            if(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['sexo'] !== undefined)
                this.handleSexoChange(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['sexo'].value);

            if(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['transgenero'] !== undefined)
                this.handleTransgeneroOtroChange(this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['transgenero'].value);
        }

        // Obtener parámetro de la edad
        this.obtenerFechaContratacionSE();
    }

    // Función que obtiene la fecha de contratación de SE - parámetro 18 en supycap.c_fechas
	obtenerFechaContratacionSE(){
		var idEstado = this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'] === null ? 0 : this.props.objetos[etiquetas.WIZARD_DATOS_CREDENCIAL]['idEstado'].value;
        const jwt = localStorage.getItem('jwt-token');

		var postData = {
            idProcesoElectoral: localStorage.getItem('id_proceso_electoral'),
			idDetalleProceso : localStorage.getItem('id_detalle_proceso'),
            idEstado : idEstado,
            idDistrito : 0,
            id : etiquetas.ID_FECHA_INICIO_CONTRATACION_CAE
		}

        axios.post(process.env.REACT_APP_API_URL +
        "/centralReclutaSEyCAE/ws/getFecha", postData,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => {
            this.setState({
                fechaContratacionSE : response.data
            });
        }).catch(error => {
            console.error("Error al consultar la fecha de contratación de SE "+
                "obtenerFechaContratacionSE()",error);
        });
	}

    handleApellidoPaternoChange = (value) => {
        this.props.form.setFieldsValue(
                {
                    apellidoPaterno: value,
                },
                () => {
                    this.props.form.validateFields(['apellidoPaterno',
                                      'apellidoMaterno'], { force: true });
                }
            );
    }

    handleApellidoMaternoChange = (value) => {
        this.props.form.setFieldsValue(
                {
                    apellidoMaterno: value,
                },
                () => {
                    this.props.form.validateFields(['apellidoPaterno', 'apellidoMaterno'], { force: true });
                }
            );
    }

    /**
     * Realiza el manejo de cambio en el control de fecha de nacimiento.
     */
    handleFechaNacimientoChange = value => {
        const startDate = moment(value, etiquetas.FORMATO_FECHA_MOMENT);
        const timeEnd = moment(this.state.fechaContratacionSE);
        const diff = timeEnd.diff(startDate);
        const diffDuration = moment.duration(diff);
        let edad = diffDuration.years();

        if(edad > 17){
            this.props.form.setFieldsValue({
                edad: edad,
            });
        } else {
            // Error menor a 17 años
            this.props.callbackResponse({1: {edad: {error: etiquetas.gral_error_menor_edad}}});
        }

        this.props.form.validateFields(['apellidoPaterno', 'apellidoMaterno', 'correoElectronico', 'confirmaCorreoElectronico', 'generoOtro', 'transgeneroOtro', 'lugarNacimiento', 'fechaNacimiento', 'sexo', 'transgenero', 'aceptaContactoCorreo'], { force: true });
        
        /* Error para adultos mayores*/
        /*if(edad >=60){
            this.props.callbackResponse({1: {edad: {error: etiquetas.gral_error_mayor_edad}}});
        }*/
    }

    handleCorreoBlur = (value, source) => {
        var correo1 = this.props.form.getFieldValue('correoElectronico');
        var correo2 = this.props.form.getFieldValue('confirmaCorreoElectronico');
        const regexCorreo = new RegExp(etiquetas.REGEX_FORMATO_CORREO);

        if(correo1 !== undefined && correo1 !== " "){
          correo1 = correo1.trim().replace(/^\s+|\s+$/gm, "");
          correo1 = correo1.trim().replace(/^\s+|\s+$|\s+(?=\s)/g, "");
          correo1= correo1.trim().replace(/\s\s+/g, "");
          correo1 = correo1.replace(/ /g, "");
        }
        if(correo2 !== undefined && correo2 !== " "){
          correo2 = correo2.trim().replace(/^\s+|\s+$/gm, "");
          correo2 = correo2.trim().replace(/^\s+|\s+$|\s+(?=\s)/g, "");
          correo2= correo2.trim().replace(/\s\s+/g, "");
          correo2 = correo2.replace(/ /g, "");
        }
        this.props.form.setFieldsValue({
          correoElectronico : correo1,
          confirmaCorreoElectronico : correo2,
          aceptaContactoCorreo : undefined
        },
        () => {
            this.props.form.validateFields(['correoElectronico',
                              'confirmaCorreoElectronico', 'aceptaContactoCorreo'], { force: true });
        }
        
        );
        var usuarioInterno = this.props.datosUsuario &&
                      this.props.datosUsuario.tipoUsuario === 'I'? true : false;
        const correoElectronico = this.props.form.getFieldValue('correoElectronico');
        const confirmaCorreoElectronico = this.props.form.getFieldValue('confirmaCorreoElectronico');
        console.info("correos ingresados", correoElectronico,"-",confirmaCorreoElectronico);
        if (!usuarioInterno) {
          if(correoElectronico !== undefined && correoElectronico.length === 0 ){
            this.props.callbackResponse({1: {correoElectronico: {
                                    error: etiquetas.general_dato_requerido}}});
          }
          if(confirmaCorreoElectronico !== undefined && confirmaCorreoElectronico.length === 0){
            this.props.callbackResponse({1: {confirmaCorreoElectronico: {
                                    error: etiquetas.general_dato_requerido}}});
          }
        }
        if(correoElectronico){
            if(!regexCorreo.test(correo1)){
              this.props.callbackResponse({1: {correoElectronico: {error: etiquetas.general_formato_invalido}}});
            }
        }
        if(confirmaCorreoElectronico){
            if(!regexCorreo.test(correo2)){
              this.props.callbackResponse({1: {confirmaCorreoElectronico: {error: etiquetas.general_formato_invalido}}});
            }
        }
        if(correoElectronico && confirmaCorreoElectronico){
            if(correoElectronico !== confirmaCorreoElectronico){
                if(source === 'correoElectronico'){
                    this.props.callbackResponse({1: {correoElectronico: {error: etiquetas.gral_correos_diferentes}}});
                }
                if(source === 'confirmaCorreoElectronico'){
                    this.props.callbackResponse({ 1 : {confirmaCorreoElectronico: {error: etiquetas.gral_correos_diferentes}}});
                }
            } else {
                // Los correos son iguales, validar si ya se encuentra registrado
                var postData = {
                    "idProcesoElectoral" : localStorage.getItem('id_proceso_electoral'),
                    "idDetalleProceso" : localStorage.getItem('id_detalle_proceso'),
                    "correoElectronico" : this.props.objetos[etiquetas.WIZARD_DATOS_PERSONALES]['correoElectronico'].value
                  }

                    // Obteniendo los datos del servidor
                    axios.post(process.env.REACT_APP_API_URL +
                        '/centralReclutaSEyCAE/ws/existeCorreo', postData,
                        {
                            headers: {
                                'Accept': 'application/json'
                                ,'Content-Type': 'application/json'
                            }
                        }
                    ).then(response => {
                        // Si el correo existe
                        if(response.data === true) {
                            this.props.form.setFieldsValue({
                                aceptaContactoCorreo:undefined
                              });

                            this.props.callbackResponse({1: {
                                correoElectronico: {error: etiquetas.gral_correo_duplicado},
                                confirmaCorreoElectronico: {error: etiquetas.gral_correo_duplicado},
                                aceptaContactoCorreo: {error: undefined}
                            }});

                            this.setState({
                                msjError : etiquetas.gral_correo_duplicado,
                                abrirModalError : true
                              });
                        }
                    }).catch(error => {
                        this.props.form.setFieldsValue({
                            aceptaContactoCorreo:undefined
                          });

                            this.props.callbackResponse({1: {
                                correoElectronico: {error: etiquetas.gral_correo_duplicado},
                                confirmaCorreoElectronico: {error: etiquetas.gral_correo_duplicado},
                                aceptaContactoCorreo: {error: undefined}
                            }});
                    });
            }
        }

    }

	handleSexoChange = (sexo) => {
            this.props.form.setFieldsValue(
                {
                    generoOtro: undefined,
                },
                    () => {
                        this.props.form.validateFields(['generoOtro'], { force: true });
                    }
                );

        if(sexo === 'O')
            this.setState({txtGeneroOtroVisible: false});
        else {
            this.setState({txtGeneroOtroVisible: true});
        }
    }
    
	handleTransgeneroOtroChange = (opcion) => {
        this.props.form.setFieldsValue(
            {
                transgeneroOtro: undefined,
            },
                () => {
                    this.props.form.validateFields(['transgeneroOtro'], { force: true });
                }
            );

        if(opcion === 'O')
            this.setState({txtTransgeneroOtroDeshabilitado: false});
        else {
            this.setState({txtTransgeneroOtroDeshabilitado: true});
        }
    }
    
    cerrarErrorModal(){
        this.setState({abrirModalError:false});
      }

    render() {
        const usuarioInterno = (this.props.datosUsuario && this.props.datosUsuario.tipoUsuario === 'I'?true:false);
        const usuario = (this.props.datosUsuario && (this.props.datosUsuario.tipoUsuario === 'I' ||
                                                            this.props.datosUsuario.tipoUsuario === 'E')?true:false);

        return(
            <React.Fragment>
                <Modal
                    className="modalError"
                    title={<img  src={errorImgModal} id="img-error-modal"/>}
                    centered
                    onCancel={()=>this.cerrarErrorModal()}
                    visible={this.state.abrirModalError}
                    footer={false}
                    width={400}
                >
                    {this.state.msjError}
                </Modal>

                <Card title={etiquetas.datos_personales_lbl_titulo} bordered={false}>
                    <Text style={{color: '#1890ff'}}>
                      <Icon type="info-circle" theme="filled"
                            style={{fontSize: '1.0em'}} />
                          Registra tu nombre tal y como aparece en tu credencial elector.
                    </Text>

                      <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="rfc"
                                    placeholder={etiquetas.datos_personales_lbl_rfc}
                                    form={this.props.form}
                                    maxLength={13}
                                    rules={[{len: 13, pattern: etiquetas.REGEX_FORMATO_RFC}]}
                                    custom={{
                                            getValueFromEvent: valueUpperCase
                                        }}/>
                        </Col>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="curp"
                                    placeholder={etiquetas.datos_personales_lbl_curp}
                                    form={this.props.form}
                                    maxLength={18}
                                    rules={[{len: 18, pattern: etiquetas.REGEX_FORMATO_CURP}]}
                                    custom={{
                                            getValueFromEvent: valueUpperCase
                                        }}/>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="apellidoPaterno"
                                    placeholder={etiquetas.datos_personales_lbl_apellidoPaterno}
                                    form={this.props.form}
                                    inputType='text'
                                    required={!this.props.form.getFieldValue("apellidoMaterno")}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    maxLength={40}
                                    rules={[{
                                                max: 40
                                                , pattern: etiquetas.REGEX_FORMATO_NOMBRES
                                            }]}
                                    custom={{
                                            getValueFromEvent: valueUpperCase
                                        }}
                                    onChange={(value) => this.handleApellidoPaternoChange(value)}/>
                        </Col>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="apellidoMaterno"
                                    placeholder={etiquetas.datos_personales_lbl_apellidoMaterno}
                                    form={this.props.form}
                                    inputType='text'
                                    required={!this.props.form.getFieldValue("apellidoPaterno")}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    maxLength={40}
                                    rules={[{
                                                max: 40
                                                , pattern: etiquetas.REGEX_FORMATO_NOMBRES
                                            }]}
                                    custom={{
                                            getValueFromEvent: valueUpperCase
                                        }}
                                    onChange={(value) => this.handleApellidoMaternoChange(value)}/>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="nombre"
                                    placeholder={etiquetas.datos_personales_lbl_nombre}
                                    form={this.props.form}
                                    inputType='text'
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    maxLength={50}
                                    rules={[{
                                                max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_NOMBRES
                                            }]}
                                        custom={{
                                            getValueFromEvent: valueUpperCase
                                        }}/>
                        </Col>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="lugarNacimiento"
                                    placeholder={etiquetas.datos_personales_lbl_lugarNacimiento}
                                    form={this.props.form}
                                    inputType='text'
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    maxLength={50}
                                    rules={[{
                                                max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                            }]}/>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                            <Calendario nombre="fechaNacimiento"
                                        placeholder={etiquetas.datos_personales_lbl_fechaNacimiento}
                                        label={etiquetas.datos_personales_lbl_fechaNacimiento}
                                        required={true}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        format={etiquetas.FORMATO_FECHA_MOMENT}
                                        formato="dd/mm/aaaa"
                                        showTime={false}
                                        showToday={true}
                                        form={this.props.form}
                                        onChange={this.handleFechaNacimientoChange}
                                        maxDate={moment().format(etiquetas.FORMATO_FECHA_MOMENT)}
                                        //maxDate={this.state.fechaContratacionSE.format(etiquetas.FORMATO_FECHA_MOMENT)}
                                        />
                        </Col>
                        <Col sm={24} md={12} lg={12} style={{'margin-top':'-7px'}}>
                            <InputText nombre="edad"
                                    placeholder={etiquetas.datos_personales_lbl_edad}
                                    form={this.props.form}
                                    inputType='text'
                                    disabled={true}
                                    required={true}
                                    rules={[{
                                                type: 'integer'
                                            }]}/>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                                <Select nombre='sexo'
                                            placeholder={etiquetas.datos_personales_lbl_sexo}
                                            form={this.props.form}
                                            required={true}
                                            showSearch={true}
                                            onChange={this.handleSexoChange}
                                            msjRequerido={etiquetas.general_dato_requerido}
                                            rules={[{
                                                    type: "enum"
                                                    , enum: ['M', 'H', 'O', 'P']
                                                }]}>
                                    <Option key="0" value={'M'}>{etiquetas.datos_personales_lbl_genero_femenino}</Option>
                                    <Option key="1" value={'H'}>{etiquetas.datos_personales_lbl_genero_masculino}</Option>
                                    <Option key="2" value={'O'}>{etiquetas.datos_personales_lbl_genero_otro}</Option>
                                    <Option key="3" value={'P'}>{etiquetas.datos_personales_lbl_genero_sin_decir}</Option>
                                </Select>
                            </Col>

                        <Col sm={24} md={24} lg={24}>
                            <InputText nombre="generoOtro"
                                        placeholder={etiquetas.datos_personales_lbl_generoOtro}
                                        form={this.props.form}
                                        inputType='text'
                                        required={!this.state.txtGeneroOtroVisible}
                                        disabled={this.state.txtGeneroOtroVisible}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        maxLength={100}
                                        rules={[{
                                                    max: 100
                                                    , pattern: etiquetas.REGEX_FORMATO_NOMBRES
                                                }]}
                                            custom={{
                                                getValueFromEvent: valueUpperCase
                                            }}/>
                        </Col>
                        
                        <Col sm={24} md={12} lg={12}>
                                <Select nombre='transgenero'
                                            placeholder={etiquetas.datos_personales_lbl_transgenero}
                                            form={this.props.form}
                                            required={true}
                                            showSearch={true}
                                            onChange={this.handleTransgeneroOtroChange}
                                            msjRequerido={etiquetas.general_dato_requerido}
                                            rules={[{
                                                    type: "enum"
                                                    , enum: ['S', 'N', 'O', 'P']
                                                }]}>
                                    <Option key="0" value={'S'}>{etiquetas.general_lbl_si}</Option>
                                    <Option key="1" value={'N'}>{etiquetas.general_lbl_no}</Option>
                                    <Option key="2" value={'O'}>{etiquetas.datos_personales_lbl_genero_otro}</Option>
                                    <Option key="3" value={'P'}>{etiquetas.datos_personales_lbl_genero_sin_decir}</Option>
                                </Select>
                            </Col>

                        <Col sm={24} md={24} lg={24}>
                            <InputText nombre="transgeneroOtro"
                                        placeholder={etiquetas.datos_personales_lbl_describe}
                                        form={this.props.form}
                                        inputType='text'
                                        required={!this.state.txtTransgeneroOtroDeshabilitado}
                                        disabled={this.state.txtTransgeneroOtroDeshabilitado}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        maxLength={100}
                                        rules={[{
                                                    max: 100
                                                    , pattern: etiquetas.REGEX_FORMATO_NOMBRES
                                                }]}
                                            custom={{
                                                getValueFromEvent: valueUpperCase
                                            }}/>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col sm={24} md={12} lg={12}>
                            <form autoComplete="off">
                                <InputText nombre="correoElectronico"
                                        placeholder={etiquetas.datos_personales_lbl_correoElectronico}
                                        required={!usuarioInterno || this.props.form.getFieldValue("confirmaCorreoElectronico")}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        form={this.props.form}
                                        maxLength={60}
                                        disabled={this.state.modifica}
                                        rules={[{
                                                    type: 'email'
                                                    , max: 60
                                                    , pattern: etiquetas.REGEX_FORMATO_CORREO
                                                }]} 
                                        onPaste={(event) => {
                                                    event.preventDefault();
                                                }}
                                        onBlur={(value) => this.handleCorreoBlur(value, 'correoElectronico')}/>
                            </form>
                        </Col>

                        <Col sm={24} md={12} lg={12}>
                            <form autoComplete="off">
                                <InputText nombre="confirmaCorreoElectronico"
                                        placeholder={etiquetas.datos_personales_lbl_confirmaCorreoElectronico}
                                        required={!usuarioInterno || this.props.form.getFieldValue("correoElectronico")}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        form={this.props.form}
                                        maxLength={60}
                                        disabled={this.state.modifica}
                                        rules={[{
                                                    type: 'email'
                                                    , max: 60
                                                    , pattern: etiquetas.REGEX_FORMATO_CORREO
                                                }]}
                                        onPaste={(event) => {
                                                    event.preventDefault();
                                                }}
                                        onBlur={(value) => this.handleCorreoBlur(value, 'confirmaCorreoElectronico')}/>
                            </form>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} md={24} lg={24}>
                            <Checkbox nombre="aceptaContactoCorreo"
                                        form={this.props.form}
                                        required={!usuarioInterno || this.props.form.getFieldValue("correoElectronico") || this.props.form.getFieldValue("confirmaCorreoElectronico")}
                                        disabled={usuarioInterno && !(this.props.form.getFieldValue("correoElectronico") || this.props.form.getFieldValue("confirmaCorreoElectronico"))}
                                        msjRequerido={etiquetas.general_dato_requerido}
                                        onChange={val => {
                                            //this.props.wizard.current.cambiaNegocio('aceptaContactoCorreo', val);
                                            this.props.form.setFieldsValue({
                                                aceptaContactoCorreo : val === false ? undefined : val
                                              },
                                              () => {
                                                  this.props.form.validateFields(['apellidoPaterno', 'apellidoMaterno', 'correoElectronico', 'confirmaCorreoElectronico', 'generoOtro', 'transgeneroOtro', 'lugarNacimiento', 'fechaNacimiento', 'sexo', 'transgenero', 'aceptaContactoCorreo'], { force: true });
                                              }
                                              );
                                        }}
                                        //validacionNegocio={!usuarioInterno || (this.props.form.getFieldValue("correoElectronico") || this.props.form.getFieldValue("confirmaCorreoElectronico"))}
                                        //validacionNegocio={!usuario || (this.props.form.getFieldValue("correoElectronico") || this.props.form.getFieldValue("confirmaCorreoElectronico"))}
                                        style={{ 'textAlign': 'justify' }}>
                                Acepto ser contactado vía correo electrónico para algún seguimiento o notificación de información sobre el proceso de reclutamiento y selección, en que estoy participando.
                            </Checkbox>
                        </Col>
                    </Row>

                </Card>
            </React.Fragment>
        );
    }
};

const mapStateToProps = state => {

    const datosUsuario = (state.sesion && state.sesion.datosUsuario) ? state.sesion.datosUsuario: undefined;

    return {
        datosUsuario: datosUsuario,
    };
}

export default connect(mapStateToProps)(DatosPersonales);
